import { takeLatest, call, put, all } from "redux-saga/effects";
import {
  GET_ALL_CATEGORIES,
  GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_REQUEST,
} from "../reducers/actionTypes";

import { actions } from "../reducers/categoriesReducer";
import {
  getAllCategories,
  getAllPrimaryCategoriesWithProductTypes,
} from "@services/api";

function* getAllCategoriesFunc() {
  try {
    const { data } = yield call(getAllCategories);
    yield put(actions.getAllCategoriesSuccess(data));
  } catch (e) {
    console.log(e);
  }
}

function* getCategoriesAndProductTypes() {
  try {
    const { data } = yield call(getAllPrimaryCategoriesWithProductTypes);
    yield put(actions.gegetAllPrimaryCategoriesWithProductTypesSuccess(data));
  } catch (error) {
    console.log(error);
  }
}

export default function* () {
  yield all([
    takeLatest(GET_ALL_CATEGORIES, getAllCategoriesFunc),
    takeLatest(
      GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_REQUEST,
      getCategoriesAndProductTypes,
    ),
  ]);
}
